<div>
  <div *ngIf="!this.displayIcon" class="lm-poll-print-status-container-noicon">
    <span class="lmPollStatusNoIcon">{{this.status}}</span>
  </div>
  <div *ngIf="this.displayIcon" class="lm-poll-print-status-container-icon">
    <svg [ngClass]="svgIconClasses" style="top: 0px !important" focusable="false" aria-hidden="true" role="presentation">
      <use [attr.xlink:href]="'#icon-' + this.iconName"></use>
    </svg>
    <span class="lmPollStatusIcon">{{this.status}}</span>
  </div>
  <div class="lmPollStatusMessage" ><span [innerHTML]="statusMessage | safe"></span></div>
</div>
